import { Item } from "./Item"
import { Profile } from "./Profile"
import { Root } from "./Root"

export const Sidebar = {
    Root,
    Item,
    Profile,
}
